module.exports = __webpack_public_path__ + "media/images/own_icon_inactive-a1363ab9.svg";